import React, {useEffect, useRef, useState} from 'react';
import {observer} from 'mobx-react';
import {CompetitorPlayersStatsModulePlayerStatsTopStats} from "./competitor-players-stats-module.player-stats.top-stats";
import {CompetitorPlayersStatsModuleStatsListViewModel} from "../../models/competitor-players-stats-module.stats-list.view-model";
import {CompetitorPlayersStatsModulePlayerStatsList} from "./competitor-players-stats-module.player-stats.list";
import {CompetitorPlayersStatsModulePlayerStatsTabs} from "./competitor-players-stats-module.player-stats.tabs";
import {CompetitorPlayersStatsModulePlayerStatsShotMap} from "./competitor-players-stats-module.player-stats.shot-map";
import {CompetitorPlayersStatsModulePlayerStatsHeatMap} from "./competitor-players-stats-module.player-stats.heat-map";
import styles from "../../styles/competitor-players-stats-module.module.scss";
import classNames from "classnames";
import {ScrollerWrapper} from "../../../../core/components/scroll-wrapper/scroll-wrapper";
import {CompetitorPlayersStatsModulePlayerPropsBet} from "./competitor-players-stats-module.player-props-bet";

export const CompetitorPlayersStatsModulePlayerStats = observer(({controller, onScrollToEnd, topStatsTitle, gameId}) => {
  const {state, device} = controller;
  const {selectedPlayer, topStatsIconSize} = state;
  const {isSmallView} = device;
  const [width, setWidth] = useState(0);

  const ref = useRef();
  const containerProps = {
    className: classNames(styles.player_stats_container),
    onScroll: (e) => {
      const target = e.target;

      if (target.scrollHeight - target.scrollTop === target.clientHeight) {
        onScrollToEnd && onScrollToEnd()
      }
    },
    ref,
  }

  const topStatsProps = {
    player: selectedPlayer,
    topStatsTitle,
    topStatsIconSize,
    isSmallView,
  }

  useEffect(() => {
    setWidth(ref.current?.clientWidth || ref.current?._container?.clientWidth);
  }, [ref.current]);


  const shotMapProps = {
    controller,
    width
  }

  const heatMapProps = {
    controller,
  }

  const propsBetProps = {
    controller,
    gameId
  }

  return (
    <ScrollerWrapper {...containerProps}>
      <CompetitorPlayersStatsModulePlayerStatsTabs controller={controller}/>
      <CompetitorPlayersStatsModulePlayerStatsShotMap {...shotMapProps}/>
      <CompetitorPlayersStatsModulePlayerStatsHeatMap {...heatMapProps}/>
      <CompetitorPlayersStatsModulePlayerPropsBet {...propsBetProps}/>
      <CompetitorPlayersStatsModulePlayerStatsTopStats {...topStatsProps}/>
      {
        selectedPlayer.playerStatsLists.map(
          (list: CompetitorPlayersStatsModuleStatsListViewModel, index: Number) =>
            <CompetitorPlayersStatsModulePlayerStatsList playerStatsList={list} key={index} controller={controller}/>)
      }
    </ScrollerWrapper>
  )
})
